import {BaseObject} from './BaseObject';
import {User} from './User';

export class ProductTransfer extends BaseObject {

    id: number;
    productId: number;
    count: number;
    userId = 1;
    user: User;
    createdAt: string;
    movementType: string;
    contractId: number;
    stockAfter: number;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductTransfer.ts